/**
 * Extracts a business-language message from a failed API call for display to
 * the user (spec 2 section 7: backend rejections -- e.g. a LOCKED-criterion
 * override slipping through, see RecruitmentCommandValidator.cs -- must read
 * as readable Polish, not a raw technical error). Backend validation
 * failures come back as `{errors: {PropertyName: [message, ...]}}` (400,
 * see ValidationExceptionFilter.cs); this flattens that into one string, or
 * returns null if the response doesn't have a recognizable shape (caller
 * should fall back to a generic message in that case).
 *
 * @param {*} error - the caught error (expected: an axios error)
 * @returns {string|null}
 */
export function extractBusinessErrorMessage(error) {
    const data = error?.response?.data;
    if (data?.errors && typeof data.errors === "object") {
        const messages = Object.values(data.errors).flat().filter(Boolean);
        if (messages.length) return messages.join(" ");
    }
    if (typeof data?.title === "string" && data.title.length) return data.title;
    return null;
}
